module.exports = __webpack_public_path__ + "static/img/logo18.a9713f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo18.png
// module id = gEeW
// module chunks = 1